import React, { Component } from 'react';
import propTypes from 'prop-types';
import { css, withStyles } from '../../assets/styles/withStyles';

class Input extends Component {
  componentDidMount() {
    if (this.props.autoFocus) {
    }
  }

  render() {
    const {
      styles,
      style,
      errorStyle,
      labelStyle,
      type,
      name,
      disabled,
      placeholder,
      label,
      error,
      value,
      onChange,
      onBlur,
      changeBorderColorOnError,
      setRef
    } = this.props;

    const classes = css(
      styles.input,
      changeBorderColorOnError && styles.borderError,
      style
    );

    const labelClasses = css(styles.label, labelStyle);

    const errorClasses = css(styles.error, errorStyle);

    return (
      <div {...css(styles.field)}>
        {label && <label {...labelClasses}>{label}</label>}
        <input
          ref={setRef}
          name={name}
          type={type}
          disabled={disabled}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          {...classes}
        />
        {error && <p {...errorClasses}>{error}</p>}
      </div>
    );
  }
}

Input.propTypes = {
  disabled: propTypes.bool,
  placeholder: propTypes.string,
  type: propTypes.oneOf(['text', 'email', 'number', 'password']),
  value: propTypes.string,
  label: propTypes.string,
  name: propTypes.string,
  error: propTypes.string,
  style: propTypes.oneOfType([propTypes.object, propTypes.array]),
  errorStyle: propTypes.oneOfType([propTypes.object, propTypes.array]),
  labelStyle: propTypes.oneOfType([propTypes.object, propTypes.array]),
  onChange: propTypes.func,
  onBlur: propTypes.func,
  changeBorderColorOnError: propTypes.bool,
  autoFocus: propTypes.bool
};

Input.defaultProps = {
  disabled: false,
  type: 'text',
  changeBorderColorOnError: false,
  autoFocus: false
};

export default withStyles(({ font, color }) => ({
  input: {
    mozAppearance: 'none',
    webkitAppearance: 'none',
    alignItems: 'center',
    boxShadow: 'none',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    position: 'relative',
    verticalAlign: 'top',
    paddingTop: 'calc(0.375em - 1px)',
    paddingRight: 'calc(0.625em - 1px)',
    paddingBottom: 'calc(0.375em - 1px)',
    paddingLeft: 'calc(0.625em - 1px)',
    fontFamily: font.family,
    width: '100%',
    maxWidth: '100%',
    transition: 'border-color 250ms',

    // Style
    backgroundColor: 'white',
    borderRadius: 2,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'hsl(0, 0%, 86%)',
    color: color.text,

    ':hover': {
      borderColor: color.text
    },

    ':focus,:active': {
      outline: 'none',
      borderColor: color.primary
    },

    ':disabled': {
      cursor: 'not-allowed'
    },

    '::placeholder': {
      color: 'hsl(0, 0%, 63%)'
    }
  },
  label: {
    display: 'block',
    color: color.text,
    marginBottom: '0.5em'
  },
  error: {
    display: 'block',
    marginTop: '0.25rem',
    fontSize: '0.75rem',
    color: color.danger
  },
  field: {
    ':not(:last-child)': {
      marginBottom: '0.75rem'
    }
  },
  borderError: {
    borderColor: color.danger
  }
}))(Input);



// WEBPACK FOOTER //
// ./src/components/form/Input.js